import { render, staticRenderFns } from "./tab_horizontal.vue?vue&type=template&id=3011d012&scoped=true"
import script from "./tab_horizontal.vue?vue&type=script&lang=js"
export * from "./tab_horizontal.vue?vue&type=script&lang=js"
import style0 from "./tab_horizontal.vue?vue&type=style&index=0&id=3011d012&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3011d012",
  null
  
)

export default component.exports